import { Box, Card, CircularProgress, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NewCardcomp from "../../../components/card/NewCardcomp";
import ReactApexChart from "react-apexcharts";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import { useGetTokenOrLogout } from "../../../utils/token";
import CircularComponent from "../Components/CircularComp";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import CustomPopup from "../../../components/CustomPopup";
import DemoDetails from "../../../newTestPrep/pages/AdvisorTaskWiseReport/DemoDetails";
import TaskDetails from "../../../newTestPrep/pages/AdvisorTaskWiseReport/TaskDetails";
import NewEnquiryComp from "../popupComponent/NewEnquiryComp";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function DemoToEnrolment() {
  const userId = localStorage.getItem("userId");

  const getTokenOrLogout = useGetTokenOrLogout();
  const [chosenDate, setChosenDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [enrolData, setEnrolData] = useState([]);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");

  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleDateChange1 = (date) => {
    setChosenDate(date);
  };

  // Trainer Demo to Enrol PiechartData
  const getPieChartData = (date) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    setLoading(true);

    const requestData = {
      user_id: userId,
      date: date,
    };

    fetch(`${API_ENDPOINT}trainerdashboard/lead-enrollent`, {
      method: "POST",
      headers,
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setEnrolData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching daily data:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getPieChartData(chosenDate);
  }, [chosenDate]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),

      date: chosenDate,
      filter_type: cardFilter,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}trainerdashboard/fetch-demo-conversion-detailed-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("User not found", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 405) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  const date = new Date(chosenDate);

  // Get month (0-based, so add 1 if you want 1-12)
  const month = date.toLocaleString("default", { month: "long" });

  // Get year
  const year = date.getFullYear(); // 2025
  return (
    <>
    <LoaderComp isLoading={detailsLoading}/>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <NewCardcomp>
            {" "}
            <Typography variant="h5" textAlign="center">
              Demo To Enrolment Conversion Breakdown
            </Typography>
          </NewCardcomp>
        </Grid>

        <Grid item xs={12}>
          <NewCardcomp height="350px">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <LeadCalandar onDateChange={handleDateChange1} />
              </Grid>
              {loading ? (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  mt={2}
                  width="100%"
                >
                  <CircularProgress />
                </Box>
              ) : (
                <>
                  <CircularComponent
                    data1={enrolData?.demo_assigned}
                    data2={enrolData?.demo_enrollment}
                    data3={enrolData?.demo_prev_enrollment}
                  />

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FF4B4B",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">Demos Assigned</Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      getCardMoreInfo("Demos Assigned", "demo_assigned")
                    }
                  >
                    <Typography variant="h6">
                      {enrolData?.demo_assigned}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#01BE85",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">Demos Converted</Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      getCardMoreInfo("Demos Converted", "demo_converted")
                    }
                  >
                    <Typography variant="h6">
                      {enrolData?.demo_enrollment}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={6}
                    display="flex"
                    direction="row"
                    alignItems="center"
                    gap={1}
                  >
                    <Box
                      sx={{
                        bgcolor: "#FABA3A",
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                      }}
                    ></Box>
                    <Typography variant="h6">
                      Demos to converted <br />
                      (Previous Assignments)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{ cursor: "pointer" }}
                    onClick={() =>
                      getCardMoreInfo(
                        "Demos Converted   (Previous Assignments)",
                        "demo_prev_enrollment"
                      )
                    }
                  >
                    <Typography variant="h6">
                      {enrolData?.demo_prev_enrollment}
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>
          </NewCardcomp>
        </Grid>
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          <DemoDetails
            SelectedData={SelectedCardData}
            monthName={month}
            selectedYear={year}
            selectedFilter="default"
          />
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
